module.exports = __webpack_public_path__ + "img/logo.ff058e16.svg";